const dateNow = new Date()

const INITIAL_STATE = {
  notifications: [],
  activePopup: true,
  loadedPopup: false,
  timePush: 0,
  lastVisualizedPush: dateNow
}

export default function notificationReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case 'SET_NOTIFICATIONS':
      return {
        ...state,
        notifications: action.notifications
      }
    case 'SET_ACTIVE_POPUP':
      return {
        ...state,
        activePopup: action.activePopup
      }
    case 'SET_ACTIVE_LOADED_POPUP':
      return {
        ...state,
        loadedPopup: action.loadedPopup
      }
    case 'SET_TIME_PUSH':
      return {
        ...state,
        timePush: action.timePush
      }
    case 'SET_LAST_VISUALIZED_PUSH':
      return {
        ...state,
        lastVisualizedPush: action.lastVisualizedPush
      }
    case 'RESET_NOTIFICATION':
      return {
        notifications: [],
        activePopup: true,
        loadedPopup: false,
        timePush: 0,
        lastVisualizedPush: dateNow
      }

    default:
      return state;
  }
}
